export default __webpack_public_path__ + "static/android-5b70ed453f90b82dacce51e6970c4e67.png";